var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_428_36151",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.03125,
    y: 0.476562,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_428_36151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5133 14.0198L12.0414 11.5664C13.0009 10.3694 13.4656 8.84997 13.3399 7.32063C13.2142 5.7913 12.5076 4.36829 11.3655 3.3442C10.2234 2.3201 8.73261 1.77277 7.1996 1.81475C5.66659 1.85672 4.20791 2.48481 3.1235 3.56986C2.0391 4.65491 1.41138 6.11446 1.36943 7.64838C1.32748 9.18231 1.87449 10.674 2.89797 11.8168C3.92146 12.9595 5.34362 13.6665 6.87205 13.7923C8.40047 13.9181 9.91898 13.4532 11.1153 12.4931L13.5672 14.9464C13.6291 15.0089 13.7028 15.0585 13.784 15.0924C13.8652 15.1262 13.9523 15.1436 14.0403 15.1436C14.1282 15.1436 14.2153 15.1262 14.2965 15.0924C14.3777 15.0585 14.4514 15.0089 14.5133 14.9464C14.6334 14.8221 14.7005 14.656 14.7005 14.4831C14.7005 14.3102 14.6334 14.1441 14.5133 14.0198ZM7.37755 12.4931C6.45512 12.4931 5.5534 12.2194 4.78643 11.7066C4.01945 11.1938 3.42167 10.465 3.06867 9.61229C2.71567 8.75957 2.62331 7.82126 2.80327 6.91601C2.98323 6.01077 3.42742 5.17925 4.07968 4.5266C4.73193 3.87396 5.56296 3.4295 6.46767 3.24944C7.37237 3.06937 8.31013 3.16179 9.16234 3.515C10.0146 3.8682 10.743 4.46634 11.2554 5.23377C11.7679 6.0012 12.0414 6.90345 12.0414 7.82643C12.0414 9.06411 11.5501 10.2511 10.6754 11.1263C9.80077 12.0014 8.61449 12.4931 7.37755 12.4931Z",
    fill: "#9C4900",
    fillOpacity: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.b20219ea54effccca9be11b09f079fc5.svg";
export { ForwardRef as ReactComponent };